import { useSelector } from 'react-redux';

import { gameRunningStatuses } from 'config/gameRunningStatuses';
import { isFulFilledEntries } from 'client/hooks/useInitPromo/userEntryState/entriesChecker';

import useHasReachPlayTimesLimit from 'client/hooks/useHasReachPlayTimesLimit';

export default function useGameActionEnableInfo() {
    const hasReachPlayTimesLimit = useHasReachPlayTimesLimit();
    const gameType = useSelector(s => s.promo.type);
    const {
        gameRunningStatus,
        periodPlayMatchedInfo: { matchedInfo: { match: isInPlayTimePeriod } = {} } = {}
    } = useSelector(s => s.promoState);
    const { notQualifiedType } = useSelector(s => s.userLoginState);
    const { hasUsablePasscode } = useSelector(s => s.promoState);
    const {
        hasGameResult,
        hasFilledSignupForm,
        hasInstantPrize,
        hasParticipantPrize,
        createEntryNotQualifiedType,
        isNeedReducePoint,
        isNeedEnterPasscode
    } = useSelector(s => s.userEntryState);
    const { playOnce } = useSelector(s => s.settingGame);

    const isGameJoinableOnTime =
        gameRunningStatus === gameRunningStatuses.RUNNING && isInPlayTimePeriod;
    const isUserInputReady = !isNeedReducePoint && (!isNeedEnterPasscode || hasUsablePasscode);
    const isQualifiedToPlayGame =
        isGameJoinableOnTime && !createEntryNotQualifiedType && !notQualifiedType;
    const shouldAutoRedirectGameStage = isQualifiedToPlayGame;
    const isQualifiedToGetWinner = isGameJoinableOnTime && !notQualifiedType;
    const canFillSignupform = isGameJoinableOnTime && hasGameResult && !hasFilledSignupForm;
    const canGetNewEntry = (() => {
        const isCurrentEntryFulfill = isFulFilledEntries(gameType, {
            hasGameResult,
            hasFilledSignupForm,
            hasInstantPrize,
            hasParticipantPrize
        });
        return isQualifiedToPlayGame && !hasReachPlayTimesLimit && isCurrentEntryFulfill;
    })();
    const canBackToJoinGamePage = isQualifiedToPlayGame && !hasGameResult;
    const canReplayCurrentEntry = isQualifiedToPlayGame && !playOnce;

    return {
        shouldAutoRedirectGameStage,
        isGameJoinableOnTime,
        isUserInputReady,
        isQualifiedToPlayGame,
        isQualifiedToGetWinner,
        canFillSignupform,
        canGetNewEntry,
        canBackToJoinGamePage,
        canReplayCurrentEntry
    };
}
